// import React, { useCallback } from "react";
// import { useNavigate, useLocation } from "react-router-dom";

// const SettingNav = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Define all tabs in one place
//   const tabs = [
//     { label: "General", path: "/setting-general" },
//     { label: "Preferences", path: "/setting-preferences" },
//     { label: "LBA configuration", path: "/setting-lbaconfig" },
//     { label: "Invoice reminder", path: "/invoicereminder" },
//     { label: "AI integration", path: "/setting-aiintegration" },
//     { label: "Security", path: "/setting-security" },
//     { label: "Billing", path: "/setting-billing" },
//     { label: "Help & support", path: "/setting-help&support" },
//     { label: "Data management", path: "/setting-datamanagement" },
//     { label: "Account", path: "/setting-account" },
//   ];

//   // Styling classes for active vs. inactive tabs
//   const baseClass =
//     "bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center py-2 px-3 box-border cursor-pointer";
//   const activeClass =
//     "bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center py-2 px-3 box-border text-primary-primary-500 border-l-[2px] border-solid border-primary-primary-500";

//   return (
//     <div className="flex flex-col items-start justify-start gap-1.5 text-neutrals-neutral-300">
//       {tabs.map((tab) => {
//         const isActive = location.pathname === tab.path;
//         return (
//           <div
//             key={tab.path}
//             className={isActive ? activeClass : baseClass}
//             onClick={() => navigate(tab.path)}
//           >
//             <div className="flex flex-row items-center justify-center">
//               <div className="relative font-semibold">{tab.label}</div>
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default SettingNav;

// Code 2
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const SettingNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    // { label: "Preferences", path: "/setting-preferences" },
    // { label: "Pre-LBA Config", path: "/setting-lbaconfig" },
   // { label: "Invoice Reminder", path: "/invoicereminder" },
    // { label: "AI Integration", path: "/setting-aiintegration" },
    { label: "Security", path: "/setting-security" },
    { label: "Billing", path: "/setting-billing" },
    { label: "FAQs", path: "/setting-help&support" },
    // { label: "Data Management", path: "/setting-datamanagement" },
    { label: "Account", path: "/setting-account" },
  ];

  return (
    <div className="flex flex-col items-start w-fit text-neutrals-neutral-300 font-semibold text-base">
      {tabs.map((tab) => {
        const isActive = location.pathname === tab.path;

        return (
          <div
            key={tab.path}
            onClick={() => navigate(tab.path)}
            className={`self-stretch cursor-pointer rounded-lg px-4 py-2 mb-1 transition-all duration-150 
              ${
                isActive
                  ? "bg-blue-50 text-primary-primary-600 font-semibold"
                  : "hover:bg-neutrals-white-light"
              }`}
          >
            {tab.label}
          </div>
        );
      })}
    </div>
  );
};

export default SettingNav;
